import React, { useState } from 'react';
import { TextField, Box, Button, Typography, Avatar } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

export default function MFAVerificationForm({ onSubmit }) {
    const [code, setCode] = useState(new Array(6).fill("")); // Creates an array with 6 empty strings

    const handleInputChange = (index) => (e) => {
        const newCode = [...code];
        newCode[index] = e.target.value.slice(0, 1); // Ensures only one character per input
        setCode(newCode);

        // Focus next input automatically after typing one digit
        if (index < 5 && e.target.value) {
            document.getElementById(`mfa-input-${index + 1}`).focus();
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (code.every(num => num !== "")) {
            console.log("MFA code submitting: ", code.join(""));
            onSubmit(code.join(""));
        } else {
            alert("Please fill all the fields.");
        }
    };

    return (
        <Box sx={{ marginTop: 8, display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
                <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">Enter MFA Code</Typography>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    {code.map((num, index) => (
                        <TextField
                            key={index}
                            id={`mfa-input-${index}`}
                            type="tel"
                            inputProps={{ maxLength: 1, pattern: "[0-9]*" }}
                            value={num}
                            onChange={handleInputChange(index)}
                            sx={{ width: '40px', textAlign: 'center' }}
                        />
                    ))}
                </Box>
                <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2, width: '100%' }}>
                    Verify
                </Button>
            </Box>
        </Box>
    );
}